// Shared webinar date/time formatting — used by the listing page, the
// dedicated detail page, and the registration modal so they all speak the
// exact same dates. Mirrors the backend helpers in
// `email_service.py:_format_webinar_date_ro` / `_format_webinar_time_label`.

export const RO_WEEKDAYS = ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"];
export const RO_MONTHS = ["ianuarie", "februarie", "martie", "aprilie", "mai", "iunie",
  "iulie", "august", "septembrie", "octombrie", "noiembrie", "decembrie"];

export function formatWebinarDate(iso) {
  if (!iso) return "";
  const d = new Date(`${iso}T12:00:00`); // noon avoids DST corner cases
  if (Number.isNaN(d.getTime())) return iso;
  return `${RO_WEEKDAYS[d.getDay()]}, ${d.getDate()} ${RO_MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function formatTimeRange(start, durationMin) {
  if (!start) return "";
  const [hh, mm] = start.split(":").map((x) => parseInt(x, 10) || 0);
  const total = hh * 60 + mm + (parseInt(durationMin, 10) || 0);
  const endHH = String(Math.floor(total / 60) % 24).padStart(2, "0");
  const endMM = String(total % 60).padStart(2, "0");
  return `${start} – ${endHH}:${endMM}`;
}
